const initialState = {
  data: [],
};

const deliveryDataSelectsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "INIT_DELIVERY_DATA_SELECTS": {
      return {
        data: action.payload,
      };
    }

    default:
      return state;
  }
};

export default deliveryDataSelectsReducer;
